/**
 * "06:30" a partir do ISO8601 devolvido pela api. Formata no fuso de Brasília,
 * não no relógio do dispositivo: o horário do celular é editável pelo usuário.
 */
export function formatReturnTime(endsAt: string | null): string | null {
  if (!endsAt) return null

  const date = new Date(endsAt)
  if (Number.isNaN(date.getTime())) return null

  return new Intl.DateTimeFormat('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'America/Sao_Paulo'
  }).format(date)
}
